<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>

export default {
  name      : 'App',
  directives: {},
  components: {},
  mixins    : [],
  dataStore : {
    AppVersion: 'App.Version',
    AppTheme  : 'App.Theme'
  },
  data() {
    return {}
  },
  computed: {
    layout() {
      return (this.$route?.meta?.layout || 'default') + '-layout'
    }
  },
  watch: {},
  created() {
    console.log('AppVersion:', this.AppVersion)
    console.log('App Theme Version:', this.AppTheme.Version)
    console.log('App Theme:', this.AppTheme.Active)
    console.log('AppConfig:', this.AppConfig)
  },
  mounted() {
  },
  updated() {
  },
  destroyed() {
  },
  methods: {}
}
</script>
